










































































import { Component, Vue } from "vue-property-decorator";
import { IContent } from "@/models/Content.model";

@Component
export default class RegistrationForm extends Vue {
  get registration() {
    return this.$store.getters.getRegistrationContent;
  }

  content: IContent = {};
  row = { participantType: "", beforeDeadline: "", afterDeadline: "" };
  fixedString = "";

  update() {
    if (this.content.text) {
      this.fixedString = this.content.text.replace(/(?:\r\n|\r|\n)/g, "<br>");
    }
    this.content.text = this.fixedString;
    this.$emit("update", this.content);
  }

  mounted() {
    this.content = Object.assign({}, this.registration);

    if (!this.content.table || this.content.table.parts.length == 0) {
      this.content.table = { parts: [{ header: "header", rows: [] }] };
    }

    if (this.content.table.parts[0].rows.length == 0)
      this.content.table.parts[0].rows.push(this.row);
  }

  addRow(partHeader: string) {
    if (!this.content.table) {
      this.content.table = { parts: [{ header: "header", rows: [] }] };
    }

    const index = this.content.table.parts.findIndex(
      (part) => part.header == partHeader
    );
    console.log(index);
    if (index !== -1)
      this.content.table.parts[index].rows.push(Object.assign({}, this.row));
    console.log(this.content.table);
  }

  deleteRow(partHeader: string) {
    if (!this.content.table) return;
    const partIndex = this.content.table.parts.findIndex(
      (part) => part.header == partHeader
    );

    this.content.table.parts[partIndex].rows.pop();
  }
}
